module.exports = __webpack_public_path__ + "static/media/partner1.27474ba1.jpg";